import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listProducts } from "../lib/api";
import { formatMoney } from "../lib/categories";
import { getProductImage } from "../lib/categoryImages";
import StarRating from "./StarRating";
import SmartImg from "./SmartImg";

export default function RelatedProducts({ product }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    if (!product?.category) return;
    setLoading(true);
    listProducts({ category: product.category, sort: "rating", limit: 24 })
      .then((data) => {
        if (!mounted) return;
        const filtered = (data.items || [])
          .filter((p) => p.id !== product.id)
          .slice(0, 8);
        setItems(filtered);
      })
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, [product?.category, product?.id]);

  if (loading || items.length === 0) return null;

  return (
    <section
      className="mt-16 border-t border-neutral-200 pt-10"
      data-testid="related-products"
    >
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-neutral-900">
            More in {product.categoryLabel}
          </h2>
          <p className="text-neutral-500 text-sm mt-1">
            Because one wasn&apos;t enough.
          </p>
        </div>
        <Link
          to={`/category/${product.category}`}
          className="text-sm font-medium text-neutral-900 hover:underline underline-offset-4"
          data-testid="related-see-all"
        >
          See all →
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.slice(0, 4).map((p) => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            className="group border border-neutral-200 rounded-xl overflow-hidden hover-lift bg-white"
            data-testid={`related-card-${p.id}`}
          >
            <div className="aspect-[4/3] bg-neutral-100 overflow-hidden">
              <SmartImg
                src={getProductImage(p)}
                alt={p.title}
                className="h-full w-full"
                imgClassName="transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-3">
              <StarRating value={p.rating} count={p.reviewCount} showValue size={12} />
              <h3 className="mt-1.5 font-display font-semibold text-sm text-neutral-900 line-clamp-2">
                {p.title}
              </h3>
              <p className="mt-1 font-display font-bold text-neutral-900">
                {formatMoney(p.price)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
